import { ActionType, OperationType } from "../util/CommonConstant";

class BaseController {
  dispatch: any;
  constructor(dispatch: any) {
    this.dispatch = dispatch;
  }
  handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    this.dispatch({
      type: ActionType.SET_INPUT_CHANGE,
      payload: { name: name, value: value },
    });
  };

  handleChange = (event: { value: any; target: { name: string } }) => {
    this.dispatch({
      type: ActionType.SET_INPUT_CHANGE,
      payload: { name: event.target.name, value: event.value },
    });
  };

  handleCheckboxChange = (event: { value: any; target: { name: string; checked: boolean } }) => {
    this.dispatch({
      type: ActionType.SET_INPUT_CHANGE,
      payload: { name: event.target.name, value: event.target.checked },
    });
  };
  
  changePageMode = (operationType: OperationType) => {
    this.dispatch({ type: ActionType.SET_OPERATION_TYPE, payload: operationType });
  };

  resetForm = () => {
    console.log("Form");
  };

  cancelForm = () => {
    console.log("Form");
  };
}
export default BaseController;
